import type { ComputedRef, InjectionKey, WritableComputedRef } from 'vue'

export interface ZPaginationContext {
  currentPage?: WritableComputedRef<number>
  pageCount?: ComputedRef<number>
  disabled?: ComputedRef<boolean>
  changeEvent?: (val: number) => void
  handleSizeChange?: (val: number) => void
}

export const zPaginationKey: InjectionKey<ZPaginationContext> =
  Symbol('drPaginationKey')
